import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout, Field, inputCls, primaryBtn } from "@/components/AuthLayout";
import { useAuth } from "@/context/AuthContext";
import { PasswordInput } from "@/components/PasswordInput";
import { GoogleButton } from "@/components/GoogleAuth";
import { errMsg, ROLE_HOME } from "@/lib/api";

export default function Login() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await signIn("/auth/login", form);
      nav(ROLE_HOME[u.role]);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in as a passenger, driver, fleet staff or administrator."
      side={{ title: "Port Moresby's trusted blue taxis.", text: "One account for riders, drivers and the Comfort Taxi fleet team." }}
    >
      <GoogleButton />
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Email">
          <input data-testid="login-email-input" type="email" required className={inputCls} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </Field>
        <Field label="Password">
          <PasswordInput testId="login-password-input" required className={inputCls} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </Field>
        <div className="-mt-2 text-right">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-sm font-semibold text-blue-700 hover:text-blue-600">Forgot password?</Link>
        </div>
        {error && <p data-testid="login-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
        <button type="submit" data-testid="login-submit-button" disabled={busy} className={primaryBtn}>{busy ? "Signing in…" : "Sign in"}</button>
      </form>
      <div className="mt-8 space-y-2 text-sm text-slate-500">
        <p>New passenger? <Link to="/register" data-testid="login-to-register-link" className="font-semibold text-blue-700">Create an account</Link></p>
        <p>Comfort Taxi driver? Your account is set up by the Comfort Taxi dispatch team.</p>
      </div>
    </AuthLayout>
  );
}
